import React from "react";
import "../pages/home.css";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div id="container">
      {/* ===== Header ===== */}
      <header
        className="header"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px",
          padding: "10px",
          position: "relative",
        }}
      >
        {/* Logo on left side */}
        <div
          className="logo"
          style={{
            position: "absolute",
            left: "20px",
            top: "20px",
            backgroundColor: "transparent",
            mixBlendMode: "multiply",
          }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/national emblem.png`}
            alt="National emblem"
            style={{ width: "100px", height: "125px" }}
          />
        </div>

        {/* Header Titles */}
        <div style={{ textAlign: "center" }}>
          <h2 className="style1">ग्रामपंचायत वलनी</h2>
          <h2 className="style1">पं.स.नागपूर जि. नागपूर</h2>
          <h2 className="style1">महारष्ट्रातील एकमेव ग्रामपंचायत उपक्रम</h2>
          <h1 className="style1">
            <u>9001:2015 Certified</u>
          </h1>
          <img
            src={`${process.env.PUBLIC_URL}/images/Isologo.png`}
            alt="Grampanchayat Logo"
            style={{ width: "55px", height: "55px" }}
          />
        </div>

        {/* === RIGHT SIDE IMAGES === */}
        <div
          style={{
            position: "absolute",
            right: "20px",
            display: "flex",
            gap: "30px",
            alignItems: "center",
            top: "30px",
          }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/swach-bharat.png`}
            alt="Swach bharat"
            style={{ width: "100px", height: "125px", borderRadius: "10px" }}
          />
        </div>
      </header>

      {/* ===== Marquee ===== */}
      <div className="style20">
        <div className="marquee">
          <p>ग्रामपंचायत वलनी – पं.स.नागपूर, जि. नागपूर</p>
        </div>
      </div>

      {/* ===== Main Menu ===== */}
      <nav className="menuicons">
        <ul>
          <li>
            <Link to="/aboutus">About Us</Link>
          </li>
          <li>
            <Link to="/">मुखपृष्ठ</Link>
          </li>
          <li>
            <Link to="/gramsevakpage">ग्रामपंचायत माहिती</Link>
          </li>
          <li>
            <Link to="/gallery">ग्रामवृत्त गॅलरी</Link>
          </li>
          <li>
            <Link to="/vikas">विकास कामे</Link>
          </li>
          <li>
            <Link to="/sabha">सभेची माहिती</Link>
          </li>
          <li>
            <Link to="/contact">संपर्क करा</Link>
          </li>
          <li>
            <Link to="/team">सदस्य</Link>
          </li>
        </ul>
      </nav>

      {/* ===== Sub Menu ===== */}
      <div className="menuicons">
        <ul>
          <li>
            <Link to="/janmdakhala">जन्म दाखला</Link>
          </li>
          <li>
            <Link to="/death">मृत्यू दाखला</Link>
          </li>
          <li>
            <Link to="/vivah">विवाह दाखला</Link>
          </li>
          <li>
            <Link to="/gramsevak">ग्रामपंचायत अधिकारी</Link>
          </li>
          <li>
            <Link to="/sarpanch">सरपंच कार्यकाल</Link>
          </li>
          <li>
            <Link to="/upsarpanch">उपसरपंच कार्यकाल</Link>
          </li>
          <li>
            <Link to="/sadasya">सदस्य कार्यकारणी</Link>
          </li>
        </ul>
      </div>

      {/* ===== Main Section ===== */}
      <main>
        <h3 className="style2">कार्यकारी मंडळ ग्रामपंचायत वलनी</h3>

        <div style={{ overflow: "auto", height: "300px" }}>
          <table>
            <thead>
              <tr>
                <th>अ.क्र.</th>
                <th>नाव</th>
                <th>पद</th>
              </tr>
            </thead>
            <tbody>
              {[
                ["1", "श्री.स्वप्नील ज्ञा.गावंडे", "सरपंच"],
                ["2", "श्री.दिनेश तू.येसनकर", "उपसरपंच"],
                ["3", "श्री.चेतन जी.कंगाले ", "सदस्य"],
                ["4", "श्री.कुमार मु.ठाकरे", "सदस्य"],
                ["5", "सौ.श्वेता वी.बेडे", "सदस्य"],
                ["6", "सौ.निलु सु.तेलंगे", "सदस्य"],
                ["7", "सौ.कल्पना पि. रामगुंडे", "सदस्य"],
                ["8", "सौ.बेबी वि. गोमासे ", "सदस्य"],
                ["9", "श्री.व्ही.आर.निस्ताने", "ग्रामपंचायत अधिकारी"],
              ].map((row, index) => (
                <tr className="EvenRowColor" key={index}>
                  {row.map((cell, i) => (
                    <td key={i}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>

      {/* ===== Footer Section ===== */}
      <footer className="footer-section">
        <ul className="social-icons">
          <li>
            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/facebook.png`}
                alt="Facebook"
              />
            </a>
          </li>
          <li>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/twitter.jpg`}
                alt="Twitter"
              />
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/kotwalbardi/?utm_source=qr&r=nametag"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/instagram.webp`}
                alt="Instagram"
              />
            </a>
          </li>
          <li>
            <a
              href="https://youtube.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/youtube.png`}
                alt="YouTube"
              />
            </a>
          </li>
        </ul>

        <p className="footer-links">
          <Link to="/copyright">Copyright Policy</Link> |{" "}
          <Link to="/disclaimer">Disclaimer</Link> |{" "}
          <Link to="/privacy">Privacy Policy</Link> |{" "}
          <Link to="/contact">Contact Us</Link>
        </p>

        <p>
          Website Designed, Developed & Maintained by{" "}
          <b>Certnexus India Pvt. Ltd. Nagpur</b>.
          <br />
          Content provided by Grampanchayat Office, Government of Maharashtra.
        </p>

        <p>© 2025 Certnexus India Pvt. Ltd. Nagpur</p>

        <div className="footer-logos">
          <a
            href="https://swachhbharatmission.ddws.gov.in/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/swach.png`}
              alt="Swachh Bharat"
            />
          </a>
          <a
            href="https://digitalindia.gov.in"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/digitalindia.webp`}
              alt="Digital India"
            />
          </a>
          <a
            href="https://data.gov.in"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/digital seva.png`}
              alt="Data Portal"
            />
          </a>
          <a
            href="https://www.india.gov.in"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/swach-bharat.png`}
              alt="National Portal"
            />
          </a>
        </div>
      </footer>
    </div>
  );
};

export default Home;
